import { memo, useEffect, useRef, useCallback } from 'react';
import type { DisplayMessage } from '../../hooks/useJames';
import { JamesMessage } from './JamesMessage';

interface JamesMessageListProps {
  messages: DisplayMessage[];
}

export const JamesMessageList = memo(function JamesMessageList({ messages }: JamesMessageListProps) {
  const endRef = useRef<HTMLDivElement>(null);
  const scrollTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Throttled auto-scroll — max once per 150ms during streaming
  const scrollToBottom = useCallback(() => {
    if (scrollTimerRef.current) return;
    scrollTimerRef.current = setTimeout(() => {
      endRef.current?.scrollIntoView({ behavior: 'smooth' });
      scrollTimerRef.current = null;
    }, 150);
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, scrollToBottom]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
    };
  }, []);

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl space-y-6">
        {messages.map((message) => (
          <JamesMessage key={message.id} message={message} />
        ))}
        <div ref={endRef} />
      </div>
    </div>
  );
});
